module.exports = __webpack_public_path__ + "files/95cd1f374859ce6d5dec9e6bef5cf473.png";